import { render, staticRenderFns } from "./PrescriptionReviewDialog.vue?vue&type=template&id=de916db8&scoped=true"
import script from "./PrescriptionReviewDialog.vue?vue&type=script&lang=js"
export * from "./PrescriptionReviewDialog.vue?vue&type=script&lang=js"
import style0 from "./PrescriptionReviewDialog.vue?vue&type=style&index=0&id=de916db8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de916db8",
  null
  
)

export default component.exports